
import React from 'react';

export const TeamIntro: React.FC = () => {
  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg mx-auto">
            <p className="text-gray-700 mb-4">
              At OMAC-UK, our team is dedicated to providing the highest standard of martial arts training in a safe, supportive, and friendly environment.
            </p>
            <p className="text-gray-700 mb-4">
              Our experienced instructors have decades of expertise, bringing a wealth of knowledge, skill, and passion to every class. Each instructor is DBS-checked and committed to helping students of all ages and abilities grow in confidence, skill, and discipline.
            </p>
            <p className="text-gray-700 mb-4">
              Supporting our instructors are our enthusiastic young helpers, who assist in classes by guiding students, demonstrating techniques, and ensuring everyone feels welcome.
            </p>
            <p className="text-gray-700 mb-4">
              Their energy and dedication make them invaluable members of our team, helping to create an engaging and dynamic learning experience for all.
            </p>
            <p className="text-gray-700">
              Together, our instructors and helpers form a strong, supportive team—ensuring that every student receives the attention, encouragement, and expertise they need to succeed.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
